/** Where your assigned courses live (12 Oct 2026): the Courses page, “For me”. A Learner's Courses
 *  page is nothing but these, so the chip is simply ignored there. */
export const LEARNING_HOME = '/courses?chip=forme'
